module.exports = __webpack_public_path__ + "static/11-efb7616f9ac673b812f8dabd4ecdddc2.png";